import React, { StrictMode, Suspense } from "react";
import RootRouter from "./screens/RootRouter";
import Loader from "./shared/components/Loader";
import "./shared/styles/lessStyle.css";
import "./shared/styles/stylings.scss";

const App: React.FC = () => {
  return (
      <Suspense fallback={<Loader />}>
            <RootRouter />
      </Suspense>
  );
};

export default App;
